"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _image = _interopRequireDefault(require("../image"));
var mapArticle = function mapArticle(responseData) {
  var _responseData$title$, _responseData$title, _responseData$title$2, _responseData$subtitl, _responseData$subtitl2, _responseData$subtitl3, _responseData$descrip, _responseData$descrip2, _responseData$descrip3;
  if (!responseData) return false;
  var articleContent = [];
  responseData.body.filter(function (item) {
    if (item.slice_type === "image") {
      var _item$primary$blurhas;
      articleContent.push({
        type: "image",
        image: (0, _image["default"])(item.primary.image, ((_item$primary$blurhas = item.primary.blurhash) === null || _item$primary$blurhas === void 0 ? void 0 : _item$primary$blurhas.length) > 0 && item.primary.blurhash[0].text),
        mode: item.primary.image_mode
      });
    }
    if (item.slice_type === "text") {
      articleContent.push({
        type: "text",
        text: item.primary.text
      });
    }
  });
  return {
    title: (_responseData$title$ = responseData === null || responseData === void 0 ? void 0 : (_responseData$title = responseData.title) === null || _responseData$title === void 0 ? void 0 : (_responseData$title$2 = _responseData$title[0]) === null || _responseData$title$2 === void 0 ? void 0 : _responseData$title$2.text) !== null && _responseData$title$ !== void 0 ? _responseData$title$ : "",
    subtitle: (_responseData$subtitl = responseData === null || responseData === void 0 ? void 0 : (_responseData$subtitl2 = responseData.subtitle) === null || _responseData$subtitl2 === void 0 ? void 0 : (_responseData$subtitl3 = _responseData$subtitl2[0]) === null || _responseData$subtitl3 === void 0 ? void 0 : _responseData$subtitl3.text) !== null && _responseData$subtitl !== void 0 ? _responseData$subtitl : "",
    description: (_responseData$descrip = responseData === null || responseData === void 0 ? void 0 : (_responseData$descrip2 = responseData.description) === null || _responseData$descrip2 === void 0 ? void 0 : (_responseData$descrip3 = _responseData$descrip2[0]) === null || _responseData$descrip3 === void 0 ? void 0 : _responseData$descrip3.text) !== null && _responseData$descrip !== void 0 ? _responseData$descrip : "",
    content: articleContent
  };
};
var _default = mapArticle;
exports["default"] = _default;